import React, { useState } from "react";
import styles from "./CheckboxFilterComponent.module.scss";
import CheckboxFilterButton from "./checkbox-filter-button/CheckboxFilterButton";
import { checkboxFilterComponentProps } from "../../../category/StoreFrontCategory";

export interface CheckboxFilterType {
	label: string
	value: string
}

type Props = {
	x: checkboxFilterComponentProps
	behaveLikeRange?: boolean
	onFilterChange: (queryParams: string) => void
};

const CheckboxFilterComponent: React.FC<Props> = (props: Props) => {
	const [ filter, setFilter ] = useState<string[]>([]);

	// Function to handle filter changes
	const onComponentFilterChange = (filter: CheckboxFilterType, isChecked: boolean) => {
		setFilter((prevSelected) => {
		  const newSelected = isChecked
			? [...prevSelected, filter.value]
			: prevSelected.filter((item) => item !== filter.value);
	
		  // Generate query string
		  const queryParams = new URLSearchParams();
		  if (props.behaveLikeRange) {
			newSelected.forEach((value) => {
				const [ min, max ] = value.split('-')

				queryParams.append(`Min${props.x.filterField}`, min !== 'Less' ? min : `0`)

				queryParams.append(`Max${props.x.filterField}`, max !== 'Above' ? max : `${"9".repeat(15)}`)
			});
		  }
		  else {
			newSelected.forEach((value) => queryParams.append(props.x.filterField, value));
		  }
	
		  // Convert query parameters to a string
		  const queryString = queryParams.toString();
		  
		  props.onFilterChange(queryString);

		  return newSelected;
		});
	  };

	return (
		<div className={styles.mainContainer}>
			<div className={styles.filterContainer}>
				<div className={styles.propertyName}>
					{props.x.filterFieldLabel}
				</div>
				<div className={styles.filterDropdown}>
					{
						props.x.data.map(x => 
							<CheckboxFilterButton key={x.label} label={x.label} filter={props.x.filterField} value={x.value} onCheck={(isChecked) => onComponentFilterChange(x, isChecked)}  />
						)
					}
				</div>
			</div>
		</div>
	);
};

export default CheckboxFilterComponent;
